import { CSSObject } from '@emotion/react';
import { theme } from 'styles';

const { color, radius } = theme;

const order: CSSObject = {
  display: 'flex',
  gap: 4,
  justifyContent: 'center',
  button: {
    width: 32,
    height: 32,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: `1px solid ${color.grey100}`,
    borderRadius: radius.sm,
    background: color.white,
    color: color.grey600,
    cursor: 'pointer',
    transition: 'background-color 0.15s ease',
    '&:hover:not(:disabled)': { background: color.grey50 },
    '&:disabled': { opacity: 0.3, cursor: 'default' },
  },
};

const icon: CSSObject = {
  width: 48,
  height: 48,
  borderRadius: 12,
  objectFit: 'cover',
  verticalAlign: 'middle',
};

const status = (isActive: boolean): CSSObject => ({
  display: 'inline-block',
  padding: '3px 10px',
  borderRadius: radius.pill,
  fontSize: 12,
  color: isActive ? color.success : color.grey500,
  background: isActive ? color.successBg : color.grey75,
  fontWeight: 600,
});

const actions: CSSObject = {
  display: 'flex',
  gap: 4,
  justifyContent: 'center',
};

const mobileRow: CSSObject = {
  display: 'flex',
  alignItems: 'center',
  gap: 12,
  padding: '12px 0',
  borderBottom: `1px solid ${color.grey75}`,
  ':last-of-type': {
    borderBottom: 'none',
  },
};

const mobileOrder: CSSObject = {
  ...order,
  flexDirection: 'column',
  flex: 'none',
};

const mobileIcon: CSSObject = {
  ...icon,
  flex: 'none',
  width: 40,
  height: 40,
  borderRadius: 10,
};

const mobileInfo: CSSObject = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: 4,
  flex: 1,
  minWidth: 0,
  p: {
    fontSize: 15,
    fontWeight: 600,
    color: color.text,
    wordBreak: 'break-all',
  },
};

const mobileAction: CSSObject = {
  flex: 'none',
  height: 34,
  padding: '0 12px',
};

export {
  order,
  icon,
  status,
  actions,
  mobileRow,
  mobileOrder,
  mobileIcon,
  mobileInfo,
  mobileAction,
};
